import React from 'react';
import { Text, VStack, HStack } from '@chakra-ui/react';
import { Button } from '../../../UI-CHAKRA/Button';
import BaseDialog from '../../../Dialogs/BaseDialog';

interface CancelRecordingDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  onCancel: () => void;
}

function CancelRecordingDialog({ isOpen, onClose, onConfirm, onCancel }: CancelRecordingDialogProps) {
  return (
    <BaseDialog isOpen={isOpen} onClose={onClose} width="340px" persist={false}>
      <VStack spacing="24px" align="center" textAlign="center">
        <Text fontSize="20px" fontWeight="600" color="#3D0E6B" lineHeight="24px">
          Deseja cancelar a gravação?
        </Text>

        <Text fontSize="14px" fontWeight="400" color="#666666" lineHeight="18px">
          Não será possível retomar.
        </Text>

        <HStack spacing="12px" width="100%">
          <Button
            flex="1"
            height="48px"
            bg="#3D0E6B"
            color="white"
            fontSize="16px"
            fontWeight="600"
            borderRadius="24px"
            _hover={{
              bg: '#2D0A4F',
              transform: 'translateY(-1px)',
              boxShadow: '0 4px 12px rgba(61, 14, 107, 0.3)',
            }}
            _active={{
              transform: 'translateY(0px)',
              bg: '#1F0735',
            }}
            transition="all 0.2s cubic-bezier(0.4, 0, 0.2, 1)"
            onClick={onCancel}
          >
            Não
          </Button>

          <Button
            flex="1"
            height="48px"
            bg="transparent"
            color="#FF6B6B"
            fontSize="16px"
            fontWeight="600"
            borderRadius="24px"
            border="2px solid #FF6B6B"
            _hover={{
              bg: '#FF6B6B',
              color: 'white',
              transform: 'translateY(-1px)',
              boxShadow: '0 4px 12px rgba(255, 107, 107, 0.3)',
            }}
            _active={{
              transform: 'translateY(0px)',
              bg: '#E55555',
            }}
            transition="all 0.2s cubic-bezier(0.4, 0, 0.2, 1)"
            onClick={onConfirm}
          >
            Sim
          </Button>
        </HStack>
      </VStack>
    </BaseDialog>
  );
}

export { CancelRecordingDialog };
